module.exports = __webpack_public_path__ + "static/media/trash_icon.c606cbfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/trash_icon.svg
// module id = 317
// module chunks = 2